(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6789],{

/***/ 93012:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/notice",
      function () {
        return __webpack_require__(17869);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_hooks_use_space__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16333);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32317);
/* harmony import */ var _styles_typography__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67246);
/* harmony import */ var _styles_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45500);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96026);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_range__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43281);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54511);
/* harmony import */ var _icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32079);















var Pagination = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.memo(function(param) {
    var numPages = param.numPages, currentPage = param.currentPage, onNextClick = param.onNextClick, onPrevClick = param.onPrevClick, onPageChange = param.onPageChange, className = param.className, _spaceTop = param.spaceTop, spaceTop = _spaceTop === void 0 ? 48 : _spaceTop, spaceBottom = param.spaceBottom;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,styletron_react__WEBPACK_IMPORTED_MODULE_5__/* .useStyletron */ .hQ)(), 1), css = ref[0];
    var ref1 = (0,_components_hooks_use_space__WEBPACK_IMPORTED_MODULE_6__/* .useSpace */ .$)({
        spaceTop: spaceTop,
        spaceBottom: spaceBottom
    }), marginTop = ref1.marginTop, marginBottom = ref1.marginBottom;
    var paginationNumbers = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        var pageNumbers = Math.floor((currentPage - 1) / 5) * 5 + 1;
        return lodash_range__WEBPACK_IMPORTED_MODULE_2___default()(pageNumbers, pageNumbers + 5).filter(function(num) {
            return num < numPages + 1;
        });
    }, [
        currentPage,
        numPages
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("pagination", className, css((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                display: "flex",
                justifyContent: "center",
                gap: "8px"
            }, marginTop, marginBottom))),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Box, {
                    onClick: onPrevClick,
                    disabled: currentPage === 1,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .J, {
                        type: "ChevronLeft",
                        size: 12,
                        color: currentPage === numPages ? _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray400 */ .O.gray400 : _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray700 */ .O.gray700
                    })
                }),
                paginationNumbers.map(function(i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Box, {
                        selected: i === currentPage,
                        onClick: onPageChange && function() {
                            return onPageChange({
                                nextPage: i,
                                prevPage: i
                            });
                        },
                        children: i
                    }, i);
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Box, {
                    onClick: onNextClick,
                    disabled: numPages === 0,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .J, {
                        type: "ChevronRight",
                        size: 12,
                        color: currentPage === numPages ? _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray400 */ .O.gray400 : _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray700 */ .O.gray700
                    })
                })
            ]
        })
    });
});
var Box = function(param) {
    var children = param.children, selected = param.selected, onClick = param.onClick, disabled = param.disabled;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,styletron_react__WEBPACK_IMPORTED_MODULE_5__/* .useStyletron */ .hQ)(), 1), css = ref[0];
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: onClick,
        disabled: disabled,
        className: css((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            backgroundColor: selected ? _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.blue50 */ .O.blue50 : _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.white */ .O.white,
            cursor: "pointer",
            width: "32px",
            height: "32px"
        }, (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .borderRadius */ .E0)("top", "8px"), (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .borderRadius */ .E0)("bottom", "8px"), (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .borderWidth */ .J4)("1px"), (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .borderStyle */ .$u)("none"), (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .borderWidth */ .J4)("1px"), (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .borderColor */ .tv)(selected ? _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.blue400 */ .O.blue400 : _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray100 */ .O.gray100)), {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }), _styles_typography__WEBPACK_IMPORTED_MODULE_12__/* .typography.ParagraphM */ .c.ParagraphM), {
            color: selected ? _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.blue400 */ .O.blue400 : _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray700 */ .O.gray700
        }), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_13__/* .transition */ .eR)()), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_obj, ":disabled", {
            color: _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray400 */ .O.gray400,
            cursor: "not-allowed",
            ":hover": {
                backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.white */ .O.white
            }
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_obj, ":hover", {
            backgroundColor: selected ? _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.blue50 */ .O.blue50 : _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray50 */ .O.gray50
        }), _obj))),
        children: children
    });
};


/***/ }),

/***/ 40307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ usePagination; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90387);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var usePagination = function() {
    var limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, pageName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "page";
    var router = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var queryPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return router.query[pageName] ? Number(router.query[pageName]) : Number(router.asPath.split("?".concat(pageName, "="))[1]);
    }, [
        pageName,
        router.asPath,
        router.query
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isNaN(queryPage) ? 1 : queryPage), page = ref[0], _setPage = ref[1];
    var setPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(nextPage) {
        router.replace({
            pathname: router.pathname,
            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, router.query), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, pageName, nextPage))
        });
    }, [
        pageName,
        router
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (queryPage && queryPage !== page) {
            _setPage(queryPage);
        }
    }, [
        page,
        queryPage,
        setPage
    ]);
    var offset = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (page - 1) * limit;
    }, [
        limit,
        page
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), countTotal = ref1[0], setCountTotal = ref1[1];
    var onPageChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(param) {
        var nextPage = param.nextPage;
        setPage(nextPage);
    }, [
        setPage
    ]);
    var onPrevClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (page > 1) {
            setPage(page - 1);
        }
    }, [
        page,
        setPage
    ]);
    var onNextClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (page < Math.ceil(countTotal / limit)) {
            setPage(page + 1);
        }
    }, [
        countTotal,
        limit,
        page,
        setPage
    ]);
    var paginationProps = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            currentPage: page,
            numPages: Math.ceil(countTotal / limit),
            onPageChange: onPageChange,
            onNextClick: onNextClick,
            onPrevClick: onPrevClick
        };
    }, [
        countTotal,
        limit,
        onNextClick,
        onPageChange,
        onPrevClick,
        page
    ]);
    return {
        limit: limit,
        offset: offset,
        paginationProps: paginationProps,
        setCountTotal: setCountTotal,
        setPage: setPage,
        countTotal: countTotal
    };
};


/***/ }),

/***/ 67134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ generatePath; }
/* harmony export */ });
/* harmony import */ var path_to_regexp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51068);

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    if (cache[path]) return cache[path];
    var generator = (0,path_to_regexp__WEBPACK_IMPORTED_MODULE_0__/* .compile */ .MY)(path);
    if (cacheCount < cacheLimit) {
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ var generatePath = function() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/", params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return path === "/" ? path : compilePath(path)(params);
};


/***/ }),

/***/ 17869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6812);
/* harmony import */ var _components_layouts_notice_layout__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(29387);
/* harmony import */ var _components_base_block__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94306);
/* harmony import */ var _components_base_typography__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(67408);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(32079);
/* harmony import */ var _components_pagination__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(34582);
/* harmony import */ var _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60369);
/* harmony import */ var _lib_hooks_use_pagination__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40307);
/* harmony import */ var _lib_routes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78954);
/* harmony import */ var _lib_utils_date_format__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(32985);
/* harmony import */ var _lib_utils_generate_path__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67134);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(32317);
/* harmony import */ var _styles_ellipsis__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(54451);
/* harmony import */ var _styles_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45500);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(43281);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54511);






















var PAGE_LIMIT = 12;
var NoticePage = function() {
    var ref;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,styletron_react__WEBPACK_IMPORTED_MODULE_3__/* .useStyletron */ .hQ)(), 1), css = ref1[0];
    var ref2 = (0,_lib_hooks_use_pagination__WEBPACK_IMPORTED_MODULE_4__/* .usePagination */ .h)(PAGE_LIMIT), paginationProps = ref2.paginationProps, setCountTotal = ref2.setCountTotal, limit = ref2.limit, offset = ref2.offset;
    var ref3 = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a)(_lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_6__/* .GetNoticesByOffsetDocument */ .mV, {
        variables: {
            offset: offset,
            limit: limit,
            sortBy: _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_6__/* .NoticeSortBy.CreatedAtDesc */ .ZP.CreatedAtDesc
        },
        onCompleted: function(param) {
            var pageInfo = param.notices.pageInfo;
            if (pageInfo) {
                setCountTotal(pageInfo.countTotal);
            }
        }
    }), data = ref3.data, loading = ref3.loading;
    var notices = (data === null || data === void 0 ? void 0 : (ref = data.notices) === null || ref === void 0 ? void 0 : ref.edges) || [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_block__WEBPACK_IMPORTED_MODULE_7__/* .BaseBlock */ .v, {
        marginTop: "40px",
        children: [
            !loading && notices.map(function(param) {
                var _node = param.node, title = _node.title, type = _node.type, id = _node.id, createdAt = _node.createdAt;
                var _obj;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: (0,_lib_utils_generate_path__WEBPACK_IMPORTED_MODULE_8__/* .generatePath */ .G)(_lib_routes__WEBPACK_IMPORTED_MODULE_9__/* .Routes.SUPPORT_NOTICE_DETAIL */ .Z.SUPPORT_NOTICE_DETAIL, {
                        id: id
                    }),
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_block__WEBPACK_IMPORTED_MODULE_7__/* .BaseBlock */ .v, {
                        as: "a",
                        className: css((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                            display: "flex",
                            alignItems: "center",
                            columnGap: "16px",
                            cursor: "pointer",
                            width: "100%",
                            boxSizing: "border-box"
                        }, (0,polished__WEBPACK_IMPORTED_MODULE_12__/* .padding */ .o3)("20px", "8px"), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_13__/* .transition */ .eR)("background-color", "0.2s"), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_13__/* .borderRadius */ .E0)(8)), {
                            ":hover": {
                                backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_14__/* .colors.gray50 */ .O.gray50
                            }
                        })),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_15__/* .Icon */ .J, {
                                type: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_6__/* .NoticeType.Notice */ .OR.Notice, "MegaphoneLoud"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_6__/* .NoticeType.Event */ .OR.Event, "CalendarCheckmark"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_6__/* .NoticeType.News */ .OR.News, "News"), _obj)[type],
                                size: 20,
                                color: _styles_colors__WEBPACK_IMPORTED_MODULE_14__/* .colors.gray600 */ .O.gray600
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_17__/* .LabelM */ .i_, {
                                flex: "1 1 auto",
                                $style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, (0,_styles_ellipsis__WEBPACK_IMPORTED_MODULE_18__/* .ellipsis */ .L)(1)),
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_17__/* .LabelXS */ .Ei, {
                                color: _styles_colors__WEBPACK_IMPORTED_MODULE_14__/* .colors.gray400 */ .O.gray400,
                                children: (0,_lib_utils_date_format__WEBPACK_IMPORTED_MODULE_19__/* .dateFormat */ .vc)(createdAt, "yyyy.MM.dd")
                            })
                        ]
                    })
                }, id);
            }),
            !loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagination__WEBPACK_IMPORTED_MODULE_20__/* .Pagination */ .t, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                className: css({
                    marginTop: "32px"
                })
            }, paginationProps))
        ]
    });
};
NoticePage.getLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts_notice_layout__WEBPACK_IMPORTED_MODULE_21__/* .NoticeLayout */ .B, {
        helmetTitle: "Ontol | 공지사항",
        children: page
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NoticePage);


/***/ }),

/***/ 54451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ellipsis; }
/* harmony export */ });
var ellipsis = function() {
    var line = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return {
        overflow: "hidden",
        display: "-webkit-box",
        "-webkit-line-clamp": line,
        "-webkit-box-orient": "vertical"
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7730,8116,4888,290,4627,3674,6030,5709,8843,2079,1319,8639,4463,9774,2888,179], function() { return __webpack_exec__(93012); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);